module.exports = __webpack_public_path__ + "static/media/igra_thumb.5ce2956c.webp";